import React from 'react'
import { useTranslation } from 'react-i18next'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { DashboardWidget } from '../../../../features/widget/types'
import { useDashboardWidgetData } from '../../../../hooks/useWidgetState'
import ErrorMessage from '../../../share/ErrorMessage'
import { GuardProps } from '../types'

const isEmptyResult = (widgetData: DashboardWidget<InsightCount>) => {
  const entries = widgetData.data[0].results![0].data.insights![0].dataset!.flatMap(
    (result) => result.set
  )
  return entries.length === 0
}

const DomainsWidgetEmptyResultGuard = ({ widgetId, children }: GuardProps): React.ReactElement => {
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)
  const { t } = useTranslation()

  if (isEmptyResult(widgetData)) {
    return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>
  }

  return children
}

export default DomainsWidgetEmptyResultGuard
